import clsx from "clsx";
import React from "react";
import * as styles from "./radio-card.css";

interface RadioCardProps {
    selected?: boolean;
    onClick?: () => void;
    banner?: React.ReactNode;
    children: React.ReactNode;
}

export function RadioCard({
    selected = false,
    onClick,
    banner,
    children,
}: RadioCardProps): React.ReactElement {
    return (
        <div
            className={clsx(styles.card, {
                [styles.selected]: selected,
                [styles.unselected]: !selected,
            })}
            onClick={onClick}
        >
            {children}
            {banner && <div className={styles.banner}>{banner}</div>}
        </div>
    );
}
